import { type FC, useContext } from "react";

import { Section, Text } from "@alpacahq/ui/old";

import { AppDetailsContext } from "./AppDetailsPage";

export const AppDetailsAbout: FC = () => {
  const {
    client: { description },
  } = useContext(AppDetailsContext);

  return (
    <Section title="About">
      <Text className="w-96 text-md">{description}</Text>
    </Section>
  );
};
